import { createSlice } from "@reduxjs/toolkit";
import { pestSpecific } from "../../../type/agri-data/pests";

export const pestSpecificsLists = createSlice({
  name: "all-pest-specifics",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: pestSpecific[];
      }[],
      data: [] as pestSpecific[],
    },
  },
  reducers: {
    updatePestSpecificsList: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    addPestSpecificsToList: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
      //include in pagination data
      const pagination_data = [...state.value.pagination];
      const lastIndex = pagination_data?.length - 1;
      const addedItem = pagination_data.map((item, index) => {
        if (lastIndex === index) {
          return {
            pagination_data: item?.pagination_data,
            data: [...item.data, action?.payload],
          };
        } else {
          return item;
        }
      });
      state.value.pagination = addedItem;
    },
    addToPestSpecificsPaginationHistory: (state, action) => {
      const found = state.value?.pagination?.find(
        (item) =>
          item?.pagination_data?.current_page ===
          action?.payload?.pagination_data?.current_page
      );
      if (!found) {
        state.value.pagination = [
          ...state.value.pagination,
          {
            pagination_data: action?.payload?.pagination_data,
            data: action?.payload?.data,
          },
        ];
      }
    },
    removePestSpecificsInList: (state, action) => {
      const { _id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { _id: string }) => v._id === _id
      );
      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1);
        state.value.data = currentArray;
      }
      //remove from paginated data
      const pagination_data = [...state.value.pagination];
      const removed = pagination_data.map((item, index) => {
        const sencondFilter = item.data.filter((data, i) => {
          return !data._id === _id;
        });
        return {
          pagination_data: { ...item.pagination_data },
          data: sencondFilter,
        };
      });
      state.value.pagination = removed;
    },
    replacePestSpecificsInList: (state, action) => {
      const { _id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { _id: string }) => v._id === _id
      );
      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1, action?.payload);
        state.value.data = currentArray;
      }
      //REPLACE pagination data
      const pagination_data = [...state.value.pagination];
      const replacedItem = pagination_data.map((item, index) => {
        const sencondFilter = item.data.map((data, i) => {
          if (data._id === _id) {
            return { ...action.payload };
          } else {
            return data;
          }
        });
        return {
          pagination_data: { ...item.pagination_data },
          data: sencondFilter,
        };
      });
      state.value.pagination = replacedItem;
    },
    clearPestSpecificsList: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  updatePestSpecificsList,
  addPestSpecificsToList,
  addToPestSpecificsPaginationHistory,
  removePestSpecificsInList,
  replacePestSpecificsInList,
  clearPestSpecificsList,
} = pestSpecificsLists.actions;

export default pestSpecificsLists.reducer;
